import { Component, LOCALE_ID, Inject, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FirestoreService } from '../../_services/firestore.service';
import { AuthService } from 'src/app/_services/auth.service';
import firebase from 'firebase/compat/app';

@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.scss'],
})
export class NotificationsModalComponent implements OnInit {
  user;
  userId;

  itemClicked;
  messages: any[]; // Replace with actual message model

  constructor(@Inject(LOCALE_ID) public locale: string,
    private authService: AuthService, 
    private firestoreService: FirestoreService) {}

  async ngOnInit() {
    this.user = await this.authService.getUser();
    this.userId = this.user.uid;

    this.loadNotifications();
  }

  loadNotifications() {
    this.firestoreService.getNotifications(this.userId).subscribe(messages => {
      if (messages) {
        this.messages = messages.reverse();

        if (this.itemClicked) {
          this.messages.map(m => {
            if (m.id == this.itemClicked.id) m.opened = true;
          });
        }
      }
    });
  }

  toggleItem(item) {
    this.itemClicked = item;
    item.opened = !item.opened;

    this.messages.map(m => {
      if (m.id != this.itemClicked.id) m.opened = false;
    });
    
    if (!item.readAt) this.firestoreService.updateNotification(item.id, this.userId);
  }

  formatMessageTimestamp(firestoreTimestamp: any): string {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const messageDate = new firebase.firestore.Timestamp(firestoreTimestamp.seconds, firestoreTimestamp.nanoseconds).toDate();
    const messageIsToday = messageDate >= today;
    const messageIsThisYear = messageDate.getFullYear() === now.getFullYear();
  
    let formatString = 'HH:mm';
    if (!messageIsToday) {
      formatString = 'dd/MM HH:mm';
    }
    if (!messageIsThisYear) {
      formatString = 'dd/MM/yyyy HH:mm';
    }
  
    return formatDate(messageDate, formatString, this.locale);
  }
}
